import React from 'react';
import { ArrowRight } from 'lucide-react';

// Shown to a SOCIETY_ADMIN whose society hasn't been fully configured yet.
// Once they complete setup and society becomes active, redirect to /dashboard.
const SetupCommunityPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--nx-navy)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'var(--font-body)',
      }}
    >
      <div
        className="nx-anim-fade-up"
        style={{
          width: '100%',
          maxWidth: 480,
          background: 'var(--nx-surface)',
          borderRadius: 20,
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 40px 120px rgba(0,0,0,0.5)',
          overflow: 'hidden',
        }}
      >
        <div style={{ height: 3, background: 'linear-gradient(90deg, #1A6CF6, #6D28D9)' }} />

        <div style={{ padding: '48px 40px', textAlign: 'center' }}>
          {/* Icon */}
          <div
            style={{
              width: 64,
              height: 64,
              background: 'linear-gradient(135deg, rgba(26,108,246,0.15), rgba(109,40,217,0.1))',
              border: '1px solid rgba(26,108,246,0.2)',
              borderRadius: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
            }}
          >
            <span style={{ fontSize: 28 }}>🏘️</span>
          </div>

          <h1
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 26,
              fontWeight: 800,
              color: 'var(--nx-text-primary)',
              letterSpacing: '-0.03em',
              marginBottom: 12,
            }}
          >
            Set up your community
          </h1>
          <p style={{ fontSize: 14, color: 'var(--nx-text-muted)', lineHeight: 1.6, marginBottom: 32 }}>
            Complete a few quick steps to configure your society on Nexora — blocks, units, and your
            first residents.
          </p>

          {/* Steps */}
          {['Configure society details', 'Add blocks & units', 'Invite residents'].map(
            (step, i) => (
              <div
                key={step}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  padding: '12px 16px',
                  background: 'var(--nx-surface-2)',
                  borderRadius: 10,
                  marginBottom: 8,
                  textAlign: 'left',
                }}
              >
                <div
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #1A6CF6, #6D28D9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#fff',
                    flexShrink: 0,
                  }}
                >
                  {i + 1}
                </div>
                <span style={{ fontSize: 14, color: 'var(--nx-text-primary)' }}>{step}</span>
              </div>
            ),
          )}

          <button
            className="nx-btn nx-btn-primary"
            style={{
              width: '100%',
              justifyContent: 'center',
              padding: '13px',
              fontSize: 14,
              fontWeight: 600,
              marginTop: 24,
            }}
            onClick={() => {
              // TODO: navigate to first step of setup wizard
            }}
          >
            Get Started <ArrowRight size={15} />
          </button>
        </div>
      </div>

      <div
        style={{
          textAlign: 'center',
          marginTop: 20,
          fontSize: 11,
          color: 'var(--nx-text-muted)',
        }}
      >
        © {new Date().getFullYear()} Pentagon Analytics. All rights reserved.
      </div>
    </div>
  );
};

export default SetupCommunityPage;
